const SKELETON_WAVE_SELECTOR = '.b-skeleton-animate-wave'
const OFFSCREEN_ROOT_MARGIN = '200px'

const getSkeletonWaves = (node: Node): Element[] => {
  if (!(node instanceof Element)) {
    return []
  }

  const nestedWaves = [...node.querySelectorAll(SKELETON_WAVE_SELECTOR)]

  return node.matches(SKELETON_WAVE_SELECTOR)
    ? [node, ...nestedWaves]
    : nestedWaves
}

export default defineNuxtPlugin(() => {
  if (!('IntersectionObserver' in window)) {
    return
  }

  const offscreenObserver = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      entry.target.toggleAttribute('data-offscreen', !entry.isIntersecting)
    }
  }, { rootMargin: OFFSCREEN_ROOT_MARGIN })

  const skeletonMutationObserver = new MutationObserver((records) => {
    for (const record of records) {
      record.removedNodes.forEach(node => getSkeletonWaves(node).forEach(wave => offscreenObserver.unobserve(wave)))
      record.addedNodes.forEach(node => getSkeletonWaves(node).forEach(wave => offscreenObserver.observe(wave)))
    }
  })

  getSkeletonWaves(document.body).forEach(wave => offscreenObserver.observe(wave))
  skeletonMutationObserver.observe(document.body, { childList: true, subtree: true })
})
